import PaymentsInterstitialModal from './PaymentsInterstitialModal';
import { useCallback, useState } from 'react';
import EmbedPointContext from './EmbedPointContext';
import { DISABLED_MODALS, Screen } from '../types/screen';
import { ModalDisplay } from '../types/paymentsInterstitialModal';
import TrackRender from '../tracking/TrackRender';
import { events } from '../tracking/events';
import { useEmbedPointModalDisplay } from '../hooks/useEmbedPointModalDisplay';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * @deprecated Use payments-embed-points-lib/components/Embed/PaymentsEmbedPointContextProvider instead. Please refer to README.md for more information.
 */
const EmbedPointContextProvider = ({
  children,
  screen,
  subscreen
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const display = useEmbedPointModalDisplay({
    subscreen
  });

  /**
   * Wraps the behavior so the behavior can be overridden to show a modal.
   *
   * Example usage:
   * const shouldDisableCallbackOnModalDisplay = true;
   * const callback = () => {
   *   // stuff the user action normally does when click happens
   * }
   *
   * onClick={handlePaymentsInterstitialModalOpen(callback, shouldDisableNormalBehavior)}
   */
  const handlePaymentsInterstitialModalOpen = useCallback((callback = () => {}, shouldDisableCallbackOnModalDisplay = false) => e => {
    setIsModalOpen(true);
    if (shouldDisableCallbackOnModalDisplay && display !== ModalDisplay.NONE) return undefined;
    return callback(e);
  }, [setIsModalOpen, display]);
  const providedProps = {
    handlePaymentsInterstitialModalOpen
  };
  const disabledModals = DISABLED_MODALS[screen] || [];
  const shouldTrackRender = screen !== Screen.CRM;
  return /*#__PURE__*/_jsxs(EmbedPointContext.Provider, {
    value: providedProps,
    children: [typeof children !== 'function' ? children : children(providedProps), !disabledModals.includes(display) && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(PaymentsInterstitialModal, {
        isModalOpen: isModalOpen,
        setIsModalOpen: setIsModalOpen,
        display: display,
        screen: screen,
        subscreen: subscreen
      }), shouldTrackRender && /*#__PURE__*/_jsx(TrackRender, {
        event: events.embedPointsPageView,
        properties: {
          screen,
          subscreen,
          displayType: display
        }
      })]
    })]
  });
};
export default EmbedPointContextProvider;